/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WeatherSummary } from './WeatherSummary';
import {
    WeatherSummaryFromJSON,
    WeatherSummaryFromJSONTyped,
    WeatherSummaryToJSON,
    WeatherSummaryToJSONTyped,
} from './WeatherSummary';

/**
 * 
 * @export
 * @interface ShowWeatherDataResponse
 */
export interface ShowWeatherDataResponse {
    /**
     * 
     * @type {Array<WeatherSummary>}
     * @memberof ShowWeatherDataResponse
     */
    data: Array<WeatherSummary>;
}

/**
 * Check if a given object implements the ShowWeatherDataResponse interface.
 */
export function instanceOfShowWeatherDataResponse(value: object): value is ShowWeatherDataResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ShowWeatherDataResponseFromJSON(json: any): ShowWeatherDataResponse {
    return ShowWeatherDataResponseFromJSONTyped(json, false);
}

export function ShowWeatherDataResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShowWeatherDataResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(WeatherSummaryFromJSON)),
    };
}

  export function ShowWeatherDataResponseToJSON(json: any): ShowWeatherDataResponse {
      return ShowWeatherDataResponseToJSONTyped(json, false);
  }

  export function ShowWeatherDataResponseToJSONTyped(value?: ShowWeatherDataResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(WeatherSummaryToJSON)),
    };
}

